import { Circle, Flex, Text } from "@chakra-ui/react";
import React from "react";
import { CheckIcon2 } from "../../../styles/icons/CheckIcon2";

interface ItemsProps {
    id: number;
    title: string;
}
interface StepComponentProps {
    section: number;
    items: Array<ItemsProps>;
}

export function StepComponentNew({
    section,
    items,
}: StepComponentProps) {
    const getStatusPosition = (position: number) => {
        if (section === position) return "current";
        if (section < position) return "future";
        return "completed";
    };

    return (
        <Flex w="100%" align="center" px={8} py={4} gap={0}>
            {items?.map((item) => {
                const status = getStatusPosition(item.id);
                const isLast = item.id === items.length;
                const isCompleted = status === "completed";
                const isCurrent = status === "current";
                const isFuture = status === "future";

                return (
                    <React.Fragment key={item.id}>
                        <Flex align="center" flexShrink={0}>
                            <Circle
                                size="32px"
                                backgroundColor={isCompleted ? "black" : "white"}
                                border={
                                    isCurrent
                                        ? "1px solid black"
                                        : isFuture
                                        ? "1px solid gray.300"
                                        : "1px solid black"
                                }
                                color={isCompleted ? "white" : isCurrent ? "black" : "gray.400"}
                            >
                                {isCompleted ? (
                                    <CheckIcon2 color="white" />
                                ) : (
                                    <Text
                                        fontSize="sm"
                                        fontWeight="600"
                                        color={isCurrent ? "black" : "gray.400"}
                                    >
                                        {item.id}
                                    </Text>
                                )}
                            </Circle>
                            <Text
                                ml="2"
                                fontSize="sm"
                                fontWeight="400"
                                color={isFuture ? "gray.400" : "black"}
                            >
                                {item.title}
                            </Text>
                        </Flex>
                        {!isLast && (
                            <Flex
                                flex={1}
                                minW="8px"
                                mx={2}
                                align="center"
                                justify="center"
                            >
                                <Flex
                                    w="100%"
                                    h={(isCurrent || isCompleted) ? "2px" : "2px"}
                                    bg={(isCurrent || isCompleted) ? "gray.700" : "gray.200"}
                                    borderRadius="full"
                                />
                            </Flex>
                        )}
                    </React.Fragment>
                );
            })}
        </Flex>
    );
}
